import api from "../../../api/axios";

const BASE_URL = "/api/v1/power/settings";

const getMySettings = async () => {
  const response = await api.get(`${BASE_URL}/me`);
  return response.data;
};

const updateProfile = async (payload) => {
  const response = await api.patch(`${BASE_URL}/profile`, payload);
  return response.data;
};

const changePassword = async (payload) => {
  const response = await api.patch(`${BASE_URL}/change-password`, payload);
  return response.data;
};

const getSessions = async () => {
  const response = await api.get(`${BASE_URL}/sessions`);
  return response.data;
};

const revokeSession = async (id) => {
  const response = await api.delete(`${BASE_URL}/sessions/${id}`);
  return response.data;
};

const revokeAllSessions = async () => {
  const response = await api.delete(`${BASE_URL}/sessions`);
  return response.data;
};

const startMfaReconfigure = async (payload) => {
  const response = await api.post(`${BASE_URL}/mfa/reconfigure/start`, payload);
  return response.data;
};

const verifyMfaReconfigure = async (payload) => {
  const response = await api.post(
    `${BASE_URL}/mfa/reconfigure/verify`,
    payload,
  );
  return response.data;
};

const settingsService = {
  getMySettings,
  updateProfile,
  changePassword,
  getSessions,
  revokeSession,
  revokeAllSessions,
  startMfaReconfigure,
  verifyMfaReconfigure,
};

export default settingsService;
